import React from 'react';

import { Stack } from '@mui/material';

const Logo = React.memo(() => (
  <Stack
    sx={(theme) => ({
      maxWidth: theme.spacing(10),
      backgroundColor: '#E8E8E8',
      padding: theme.spacing(1.5, 2),
      borderRadius: theme.spacing(1),
    })}
  >
    <img
      srcSet={require('../../assets/logo.png')}
      src={require('../../assets/logo.png')}
      alt="Logo"
    />
  </Stack>
));

export default Logo;
